import React, { useState, useEffect, useRef } from 'react';
import { UserIcon as PersonIcon } from '@phosphor-icons/react';
import { getLiveLayoutColors } from './RunOfShow/helper/presentationLive';
import Tooltip from '@atoms/new/tooltip';

const ParticipantsLimit = ({ hasReachedMaxParticipants, maxParticipants, noOfParticipants, text, layoutTheme = 'dark', setShowMenu = () => { }, isDisabled = false, linkLibrary, quickQuestions }) => {
  const colors = getLiveLayoutColors(layoutTheme);
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    let timer;

    if (!isDisabled && hasReachedMaxParticipants && !isHovered) {
      setShowMenu(true);
      timer = setTimeout(() => {
        setTooltipOpen(true);
      }, 3000);
    }

    return () => clearTimeout(timer);
  }, [hasReachedMaxParticipants, isHovered, isDisabled]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setTooltipOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMouseEnter = () => {
    setIsHovered(true);
    setTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setTooltipOpen(false);
  };

  return (
    <div
      ref={containerRef}
      className={`w-full flex items-center h-12 rounded-full ${colors.containerColor} ${colors.textColor} ${colors.hoverBg} group p-0.5 ${isDisabled ? 'cursor-not-allowed opacity-50' : ''}`}
      onMouseEnter={isDisabled ? undefined : handleMouseEnter}
      onMouseLeave={isDisabled ? undefined : handleMouseLeave}
    >
      <Tooltip
        isOpen={isTooltipOpen}
        onClose={() => {
          if (!hasReachedMaxParticipants || !isHovered) {
            setTooltipOpen(false);
          }
        }}
        content={
          <>
            <h4 className='text-sm font-semibold mb-2 text-left w-full'>
              {hasReachedMaxParticipants ? 'Limit Reached' : 'Session commenters '}
            </h4>
            <div className='text-sm font-normal'>
              {hasReachedMaxParticipants ? (
                <>
                  Your session has <span className="font-semibold">{maxParticipants} commenters</span>. Please upgrade to accommodate more.
                </>
              ) : (
                <>
                  You have <span className="font-semibold">{noOfParticipants} {noOfParticipants <= 1 ? 'commenter' : 'commenters'}</span> in this live session.{maxParticipants !== 'Unlimited' ? <> Your plan has a limit of {<span className="font-semibold">{maxParticipants}</span>}</> : ''}
                </>
              )}
            </div>
          </>
        }
        placement='top-end'
      >
        <div
          id='tooltip'
          className='group w-full h-full flex items-center justify-center rounded-full'
        >
          <div className='flex items-center gap-1'>
            <PersonIcon size={16} className={`${colors.textColor} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`} />
            <div className={`text-sm ${isDisabled ? 'cursor-not-allowed' : ''}`}>{text}</div>
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

export default ParticipantsLimit;
